import React, { PropsWithChildren, useLayoutEffect, useState } from 'react';
import { Fullscreen } from '../../../context/Fullscreen';
import { Orientation, Orientations } from '../../../context/Orientation';
import { PreviewSize, SupportedPreviewSizes } from '../../../context/PreviewSize';

export const GiftWindowProviderStack = ({ children, deps }: Props) => {

    const [previewSize, setPreviewSize] = useState<SupportedPreviewSizes>('small');
    const [fullscreen, setFullscreen] = useState<boolean>(false);
    const [orientation, setOrientation] = useState<Orientations>('portrait');

    useLayoutEffect(() => setFullscreen(false), [...deps]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <PreviewSize.Provider value={{ previewSize, setPreviewSize }}>
            <Fullscreen.Provider value={{ fullscreen, setFullscreen }}>
                <Orientation.Provider value={{ orientation, setOrientation }}>
                    {children}
                </Orientation.Provider>
            </Fullscreen.Provider>
        </PreviewSize.Provider>
    );
};

type Props = PropsWithChildren<{
    deps: any[];
}>;